import { Component, OnInit, OnDestroy } from "@angular/core";
import { AuthenticationService } from "../../services/authentication.service";
import { Router } from "@angular/router";
import { SharedService } from "../../services/shared.service";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/takeUntil";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  credentials: any = {};
  existingEmailsList = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private shared: SharedService
  ) {}

  ngOnInit() {
    this.shared.changeShowInfo(false);
  }

  register() {
    this.auth
      .register(this.credentials)
      .takeUntil(this.destroy$)
      .subscribe(
        () => {
          this.router.navigateByUrl("profile");
        },
        err => {
          if (err.status === 528) {
            this.existingEmailsList = true;
          }
          console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }
}
